import React, {Component} from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux';

import TemplateListHeader from '../../components/contents/template/TemplateListHeader'
import TemplateList from '../../components/contents/template/TemplateList'
import Pagination from '../../components/common/Pagination';
import { parseListParams } from '../../components/common/EntryListHelper';
import ListWriteTitle from "../../components/common/list/ListWriteTitle";

@connect(state => ({
    items: state.template.item.items,
    totalCount: state.template.item.totalCount,
    searchKeyword: state.template.condition.searchKeyword,
}))
class TemplateApp extends Component {

    render() {
        const { totalCount, searchKeyword } = this.props;

        return (
				<div className="inner_article contents_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
					<ListWriteTitle type="template" headLabel="서식" totalCount={totalCount} searchKeyword={searchKeyword}/>
					<Route path="/templates" exact={false} strict={false} component={TemplateListHeader}/>
					<Route path="/templates" exact={false} strict={false} component={TemplateList}/>
					<Pagination totalCount={totalCount} parseListParams={parseListParams}/>
				</div>
        )
    }
}

export default TemplateApp;
